import { Component, inject, signal } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { AuthService } from '../core/auth.service';
import { errorMessage } from '../core/http-error';
import { LanguageService } from '../core/language';

@Component({
  selector: 'app-signin',
  imports: [ReactiveFormsModule, RouterLink],
  templateUrl: './signin.html',
})
export class SignInPage {
  private readonly auth = inject(AuthService);
  private readonly router = inject(Router);
  private readonly route = inject(ActivatedRoute);
  protected readonly lang = inject(LanguageService);
  protected readonly submitting = signal(false);
  protected readonly serverError = signal<string | null>(null);

  constructor() {
    if (this.auth.signedIn()) {
      void this.router.navigateByUrl(this.destination());
    }
  }

  protected readonly form = inject(FormBuilder).nonNullable.group({
    email: ['', [Validators.required, Validators.email]],
    password: ['', Validators.required],
  });

  protected submit(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }
    this.submitting.set(true);
    this.serverError.set(null);
    const { email, password } = this.form.getRawValue();
    this.auth.login(email, password).subscribe({
      next: () => void this.router.navigateByUrl(this.destination()),
      error: (error: unknown) => {
        this.submitting.set(false);
        this.serverError.set(errorMessage(error, this.lang.t('inFail')));
      },
    });
  }

  private destination(): string {
    const url = this.route.snapshot.queryParamMap.get('returnUrl') ?? '/portfolio';
    const next = url.startsWith('/') && !url.startsWith('//') ? url : '/portfolio';
    if (this.auth.user()?.detailsPending && (next === '/portfolio' || next.startsWith('/portfolio?'))) {
      return '/details';
    }
    return next;
  }
}
